<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>New Supplier Payment</v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- <v-btn text to="/supplier-payments">
          <v-icon left>mdi-arrow-left</v-icon>Back
        </v-btn>-->
      </v-toolbar>

      <v-card-text>
        <v-form ref="supplierReceiptForm" v-model="valid" :lazy-validation="lazy">
          <v-row dense class="subtitle-2 text--primary mb-2">
            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="record.SupplierId"
                :items="suppliers"
                item-text="Name"
                item-value="id"
                label="Select Supplier"
                outlined
                dense
                clearable
                :search-input.sync="searchSuppliers"
                @change="fetchInvoices(record.SupplierId)"
                :rules="inputRules"
              ></v-autocomplete>

              <div class="mt-2 style-18">Current Bal: {{ currentBalance | currency }}</div>

              <div class="mt-2 style-18">Receipt No:</div>
              <br />

              <div style="margin-top: 10px">
                <DatePicker
                  @date="setDocDate"
                  :myDate="record.DocDate"
                  :title="`Select Payment Date`"
                ></DatePicker>
              </div>
            </v-col>
            <!-- end of col 1 -->

            <!-- start of col 2 -->
            <v-col cols="12" md="4" class="px-4">
              <v-text-field
                type="number"
                autocomplete="off"
                outlined
                dense
                label="Amount Paid"
                v-model="record.AmountPaid"
                :rules="inputRules"
              ></v-text-field>

              <v-autocomplete
                class="mt-2"
                v-model="record.AccountId"
                :items="accounts"
                item-text="Name"
                item-value="id"
                label="Bank Account"
                outlined
                dense
                clearable
                :rules="inputRules"
              ></v-autocomplete>

              <v-autocomplete
                class="mt-2"
                v-model="record.PaymentModeId"
                :items="paymentModes"
                item-text="Name"
                item-value="id"
                label="Payment Mode"
                outlined
                dense
                clearable
              ></v-autocomplete>

              <v-text-field
                class="mt-2"
                autocomplete="off"
                outlined
                dense
                label="Ref NO:"
                v-model="record.RefNo"
              ></v-text-field>
            </v-col>

            <!-- start of col 3 -->

            <v-col cols="12" md="4">
              <v-textarea
                rows="2"
                outlined
                dense
                label="Description / Comments"
                v-model="record.Narration"
                class="mb-2"
              ></v-textarea>

              <div class="mt-2">
                <DatePicker
                  class="mt-2"
                  @date="setChequeDate"
                  :myDate="record.ChequeDate"
                  :title="`Select Cheque Date`"
                ></DatePicker>
              </div>

              <div class="mt-2">
                <DatePicker
                  @date="setBankDate"
                  :myDate="record.BankDate"
                  :title="`Select Bank Date`"
                ></DatePicker>
              </div>
            </v-col>
          </v-row>

          <v-row class="subtitle-2 text--primary">
            <v-col cols="12">
              <v-radio-group dense label="Payment Option:" v-model="record.PaymentOption" row>
                <v-radio label="Autoclear Invoices" value="C"></v-radio>
                <!-- <v-radio label="Allocate Invoices" value="A"></v-radio> -->
                <!-- <v-radio label="Post Unallocated" value="U"></v-radio> -->
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row
            style="background-color: #E9EAEC"
            class="subtitle-2 text--primary"
            v-if="record.PaymentOption == 'A'"
          >
            <v-col cols="12">
              <v-data-table
                dense
                v-model="selected"
                hide-default-footer
                :items-per-page="pageItems"
                :headers="headers"
                :items="invoices"
                :search="search"
                :mobile-breakpoint="zeroValue"
                item-key="InvoiceId"
                show-select
              >
                <!--  template -->
                <template
                  v-slot:item.DocTotal="{ item }"
                >{{ item.DocTotal && item.DocTotal | currency }}</template>
                <!-- end -->

                <!-- template -->
                <template
                  v-slot:item.TotalPaid="{ item }"
                >{{ item.TotalPaid && item.TotalPaid | currency }}</template>
                <!-- end -->

                <!-- template -->
                <template
                  v-slot:item.Balance="{ item }"
                >{{ item.Balance && item.Balance | currency }}</template>
                <!-- end -->

                <!-- template -->
                <template v-slot:item.DocDate="{ item }">{{ item.DocDate && item.DocDate | date }}</template>
                <!-- end -->
              </v-data-table>
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <v-row class="mt-2 subtitle-2 text--primary">
            <v-col cols="6" v-if="record.PaymentOption == 'A'">
              <span class="style-16">Selected Invoices</span>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Invoice No</th>
                      <th class="text-left">Invoice Amount</th>
                      <th class="text-left">Invoice Date</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="item in selected" :key="item.InvoiceId">
                      <td>{{ item.DocNum }}</td>
                      <td>
                        <span class="custom-accent">{{ item.DocTotal | currency }}</span>
                      </td>
                      <td>{{ item.DocDate | date }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>

            <v-col cols="12">
              <div
                class="mt-4 mb-2 style-24 float-right"
              >Amount Paid: {{ record.AmountPaid ? (parseFloat(record.AmountPaid).toLocaleString()) : 0.0}}</div>
              <br />
              <br />
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <v-row class="mt-1">
            <v-col cols="12">
              <v-btn
                color="primary"
                class="mt-1 float-right"
                @click="sendData"
                :loading="$store.state.btnLoader"
                :disabled="$store.state.btnLoader"
              >
                <v-icon left>mdi-content-save</v-icon> Make Payment
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>
  
  <script>
export default {
  components: {},
  data: () => ({
    record: {},
    valid: false,
    lazy: false,
    currentBalance: 0,
    selected: [],
    selectedSupplier: null,
    searchSuppliers: null,
    paymentModes: [],
    suppliers: [],
    accounts: [],
    pageItems: 100,
    zeroValue: 0,
    totalDebt: 0,
    search: "",
    invoices: [],
    date: null,
    inputRules: [v => !!v || "Required"],
    headers: [
      { text: "Invoice No", value: "DocNum" },
      { text: "Total", value: "DocTotal" },
      { text: "Amount Paid", value: "TotalPaid" },
      { text: "Balance", value: "Balance" },
      { text: "Date", value: "DocDate" }
    ],
    debtors: []
  }),
  computed: {
    role() {
      return localStorage.getItem("userRole");
    },
    userRole() {
      return localStorage.getItem("userRole");
    }
  },
  watch: {
    searchSuppliers(val) {
      if (val && val !== this.select && this.querySuppliers(val)) {
        this.querySuppliers(val);
      }
    }
  },
  methods: {
    setDocDate(date) {
      this.record.DocDate = date;
    },
    setChequeDate(date) {
      this.record.ChequeDate = date;
    },
    setBankDate(date) {
      this.record.BankDate = date;
    },
    sendData() {
      if (!this.$refs.supplierReceiptForm.validate()) {
        this.$refs.snackbar.show("Please fill all the fields", "red");
        return;
      }

      if (this.record.DocDate == undefined || this.record.DocDate == null) {
        this.$refs.snackbar.show("Please select payment date", "red");
        return;
      }

      if (this.record.PaymentOption == undefined) {
        this.$refs.snackbar.show("Please select payment option", "red");
        return;
      }

      if (this.record.PaymentOption == "A" && this.selected.length == 0) {
        this.$refs.snackbar.show(
          "Please select invoices to allocate payment",
          "red"
        );
        return;
      }

      if (this.record.PaymentOption == "U") {
        this.$refs.snackbar.show(
          "This payment option are under development",
          "orange"
        );
        return;
      }

      // if (this.record.AmountPaid > this.currentBalance) {
      //   this.$refs.snackbar.show(
      //     "You cannot pay more than the customer balance",
      //     "red"
      //   );
      //   return;
      // }

      var todayDate = new Date().toISOString().substr(0, 10);

      if (
        this.record.ChequeDate == undefined ||
        this.record.ChequeDate == null
      ) {
        this.record.ChequeDate = todayDate;
      }

      if (this.record.BankDate == undefined || this.record.BankDate == null) {
        this.record.BankDate = todayDate;
      }

      var invoices = this.selected;
      var selectedIds = [];
      for (const invoice of invoices) {
        selectedIds.push(invoice.InvoiceId);
      }

      var data = {
        AccountId: parseInt(this.record.AccountId),
        AmountPaid: parseFloat(this.record.AmountPaid),
        RequestDocDate: this.record.DocDate,
        RequestBankDate: this.record.BankDate,
        RequestChequeDate: this.record.ChequeDate,
        SupplierId: parseInt(this.record.SupplierId),
        PaymentModeId: parseInt(this.record.PaymentModeId),
        Narration: this.record.Narration,
        RefNo: this.record.RefNo,
        SelectedIds: selectedIds
      };

      var url = "";

      if (this.record.PaymentOption == "A") {
        url = "/create-supplier-payment";
      }

      if (this.record.PaymentOption == "C") {
        url = "/create-supplier-payment-autoclear";
      }

      const self = this;
      self.$store.commit("btnLoader", true);
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            self.$router.push("/supplier-payments");
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    querySuppliers(searchText) {
      const self = this;
      const url = "/suppliers/search";
      const data = {
        searchText: searchText
      };

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.suppliers = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    fetchInvoices(id) {
      const self = this;
      this.$store
        .dispatch("get", `/creditor-invoices/${id}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.invoices = res.ResponseData.unclearedInvoices;
            self.currentBalance = res.ResponseData.currentBalance;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    fetchAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/bank-accounts`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    fetchPaymentModes() {
      const self = this;
      this.$store
        .dispatch("get", `/payment-modes`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.paymentModes = res.ResponseData;
            self.record.PaymentOption = "C";
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    Promise.all([this.fetchPaymentModes(), this.fetchAccounts()]);
  }
};
</script>